import { Container, Frame, Content, Header } from '@kinesis/bungle';
import type { Session, Flag, Inventory } from '@/types';
import { BrandBackground } from '@/components/brand-background';
import { PrimaryNavigation } from '@/components/primary-navigation';
import { noop } from 'lodash/fp';

const AppLayout = (props: AppLayoutProps) => {
  const {
    children,
    enableFlags,
    enableBaseline,
    enableGpc,
    flags,
    session,
    onLogout = noop,
    onToggleFlag,
    onOpenSwitcher,
    inventoryId,
    inventory,
  } = props;

  return (
    <Container>
      <Frame>
        <BrandBackground>
          <Container>
            <Header>
              <PrimaryNavigation
                inventoryId={inventoryId}
                flags={flags}
                enableFlags={!!enableFlags}
                enableBaseline={!!enableBaseline}
                enableGpc={!!enableGpc}
                onToggleFlag={onToggleFlag}
                session={session}
                onLogout={onLogout}
                onOpenSwitcher={onOpenSwitcher}
                inventory={inventory}
              />
            </Header>

            <Frame>
              <Content sizing='fill-container' height='100%' background='gray'>
                {children}
              </Content>
            </Frame>
          </Container>
        </BrandBackground>
      </Frame>
    </Container>
  );
};

export type AppLayoutProps = {
  children?: JSX.Element;
  inventoryId: number;
  enableFlags?: boolean;
  enableBaseline?: boolean;
  enableGpc?: boolean;
  flags: Flag[];
  onLogout?: () => void;
  onToggleFlag?: (name: string) => void;
  session?: Session;
  onOpenSwitcher?: () => void;
  inventory?: Inventory;
};

export { AppLayout };
